<div class="modal-header navbar-alertia">
    <h4 class="modal-title">{{title}}</h4>
    <button type="button" title="{{ 'general.close_window' | translate }}" class="close" (click)="activeModal.close(false)">&times;</button>
</div>
<div class="modal-body">
    <div class="row text-break">
        <div class="col-12" [innerHtml]="message">
        </div>
    </div>
</div>
<div class="modal-footer text-right">
    <button type="button" title="{{'general.cancel' | translate}}" class="btn btn-red btn-h-red mr-2" (click)="activeModal.close(false)">
        {{'general.cancel' | translate}}
    </button>
    <button type="button" title="{{'general.confirm' | translate}}" class="btn btn-green btn-h-green" (click)="activeModal.close(true)">
        {{'general.confirm' | translate}}
    </button>
</div>
